export type StoreCatalogPartnerRef = {
  id: string
  label: string
}

export type StoreRewardCategoryRef = {
  id: number
  name: string
}

export type StoreCatalogItem = {
  id: number
  name: string
  coin: number
  quantity?: number
  quantity_sold?: number
  partner_id?: number
  partner?: { id: number; name: string } | null
  reward_category?: StoreRewardCategoryRef | null
  reward?: {
    partner_id?: number
    partner?: { id: number; name: string } | null
    reward_category?: StoreRewardCategoryRef | null
  } | null
  _requests: unknown[]
}

export type StoreAdvancedFilters = {
  available: boolean
  soldOut: boolean
  requested: boolean
  affordable: boolean
  partnerId: string | null
  categoryId: string | null
}

export const EMPTY_STORE_ADVANCED_FILTERS: StoreAdvancedFilters = {
  available: false,
  soldOut: false,
  requested: false,
  affordable: false,
  partnerId: null,
  categoryId: null
}
